import { Component, OnInit } from '@angular/core';
import { IPeripheral } from '@app/interfaces/IPeripheral';
import { ProductVendor } from '@app/main/components/videos/enums/CameraProductType';
import { PeripheralService } from '@app/main/modules/foundation/_services/peripheral.service';
import { IConfigurationUpdate } from '@app/services/cameraCommunicationServer.service';
import { NavigationService } from '@app/services/navigation.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import './peripheral-view.component.scss';

@UntilDestroy()
@Component({
    selector: 'peripheral-view',
    template: require('./peripheral-view.component.html')
})
export class PeripheralViewComponent implements OnInit {
    peripheralId: number;
    peripheralSerial: string;
    peripheral: IPeripheral;

    deviceTypeId: number;
    deviceId: number;
    isAutoDeployment: boolean;
    currentConfigId: number;
    configHistoryData: IConfigurationUpdate[] = [];


    loading: boolean;
    saving: boolean;


    constructor(
        private readonly navigationService: NavigationService,
        private readonly peripheralService: PeripheralService) { }

    ngOnInit(): void {
        this.peripheralSerial = this.navigationService.getRouteParam("serial");
        this.loadData();
    }

    get showSimTab(): boolean {
        return this.peripheral?.Product?.GroupId !== ProductVendor.TachoSys && this.peripheral?.Product?.GroupId !== ProductVendor.SevenTelematics;
    }

    //--

    private loadData(): void {
        this.loading = true;
        this.getPeripheral()
        .pipe(
            untilDestroyed(this))
            .subscribe({
                next: () => {
                    this.loading = false;
                }
            })
    }

    private getPeripheral(): Observable<IPeripheral> {
        return this.peripheralService.getPeripheralBySerial(this.peripheralSerial).pipe(tap(peripheral => {
            this.peripheral = peripheral;

            if (!this.peripheral) {
                return;
            }

            this.navigationService.updateBreadcrumbNameResolver({
                peripheralNameBreadcrumbKey: this.peripheral.name,
            });
        }));
    }


}
